
export { };

let slideshow = document.querySelectorAll<HTMLElement>("#pics");
let displayed = 0;

let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

function reload() {
	let n = 0;
	for (let gallery of slideshow) {
		n = gallery.children.length;
		for (let child of gallery.children) { (child as HTMLElement).style.display = "none"; }
		(gallery.children[((displayed % (n)) + n) % n] as HTMLElement).style.display = "block";
	}
}
function setAllStyle(style: string, width: string, query: string) {
	let elems = document.querySelectorAll<HTMLElement>(query);
	for (let element of elems) {
		element.style[style] = width;
	}
}

document.addEventListener("DOMContentLoaded", (_) => {
	if (vw > vh) {
		setAllStyle("width", "30vw", ".right");
		setAllStyle("height", "80vh", ".left");
		setAllStyle("width", "30vw", "img");
		setAllStyle("width", "30vw", ".walign");
	}
	else {
		setAllStyle("width", "80vw", ".right");
		setAllStyle("width", "80vw", "img");
		setAllStyle("width", "80vw", ".walign");
	}
	reload();
});

setInterval(() => { reload(); displayed++; }, 1500);

